import axios from './axios'
// import qs from "qs";

function service(endpoint) {


    function fetchRoles(id, params = {}) {
        return axios.get(`${endpoint}/role-tree/${id}`, {params}).then(response => {
            return response.data;
        }).catch(e => {
            throw e
        });
    }

    function saveRoles(id, data = {}) {
        return axios.post(`${endpoint}/role-tree/${id}`, data).then(response => {
            return response.data;
        }).catch(e => {
            throw e
        });
    }

    return {
        fetchRoles,
        saveRoles
    }
}

export default service
